module.exports = __webpack_public_path__ + "img/1514707933.6882071c.jpg";